const IS_SERVER = typeof window === 'undefined'

export default IS_SERVER
